export default __webpack_public_path__ + "67ed6537ceee1e738d32560666da5b5d.png";